import firebase from 'firebase'
import Fuse from 'fuse-js-latest'
import { event } from 'vue-analytics'

import moment from 'moment'

const DATEFORMAT = "ddd, MMM D h:mmA"


export default {
    state: {      
      isSyncedPosts: false,
      careerPosts: [],
      businessPosts: [],
      eventPosts: [],
      infoPosts: [],
      myPosts: [],
      myPostsCommented: []
 
    },
    mutations: {
        setIsSyncedPosts(state, payload){
            state.isSyncedPosts = payload
        },
        setCareerPosts (state, payload) {
            state.careerPosts = payload
        },
        setBusinessPosts (state, payload) {
            state.businessPosts = payload
        },
        setEventPosts (state, payload) {
            state.eventPosts = payload
        },
        setInfoPosts (state, payload) {
            state.infoPosts = payload
        },
        setInfoPostsCommented (state, payload) {
            state.myPostsCommented = payload
        },        
        setMyPosts (state, payload) {
            state.myPosts = payload
        },
        resetPostState(state){
            state.isSyncedPosts= false
            state.careerPosts= []
            state.businessPosts= []
            state.eventPosts= []
            state.infoPosts= []
            state.myPosts= []
            state.myPostsCommented= []            
        }
    },
    actions: {
        clearError ({commit}) {
            commit('clearError')
        },
        writePostToDb ({commit}, payload) {
            return new Promise((resolve, reject) => {     
                commit('setLoading', true)
                firebase.firestore().collection(payload.org).doc(payload.postid).set(payload)
                .then(function() {
                    //console.log("Document successfully written!")
                    event('post', 'submitted', payload.category ) //GA EVENT
                    resolve('success')
                    commit('setLoading', false)
                })
                .catch(function(error) {
                    console.error("Error writing document: ", error)
                    reject('failure')
                    commit('setLoading', false)
                })
            })
        },
        addCommentToPost ({commit}, payload) {
            return new Promise((resolve, reject) => {     
                commit('setLoading', true)
                var tmpcomment = payload.comment
                var collectionRef = firebase.firestore().collection(payload.org).doc(payload.postid)
                collectionRef.get().then(doc=>{
                    collectionRef.update({comments: firebase.firestore.FieldValue.arrayUnion(tmpcomment)});
                    //console.log('updating comments in document w/ docid: ' + doc.id)
                    var tmpparticipatingmemberids =  doc.data().participatingmemberids
                    if(!tmpparticipatingmemberids.includes()){
                      collectionRef.update({participatingmemberids: firebase.firestore.FieldValue.arrayUnion(tmpcomment.userid)});
                      //console.log('updating participatingmemberids in document w/ docid: ' + doc.id)
                      event('post', 'commented', 'Comment Added To Post' ) //GA EVENT
                    }

                    resolve('success')
                    commit('setLoading', false)
                }).catch(err => {
                    //console.log('Error getting documents', err);
                    reject('failure')
                    commit('setLoading', false)                    
                  })

            })
        },
        addFileToPost ({commit}, payload) {
            return new Promise((resolve, reject) => {     
                commit('setLoading', true)
                var tmpfile = payload.fileurl
                var tmpfilename = payload.filename
                var tmpfiletype = payload.filetype
                var tmpfilepath = payload.filepath
                var objFile = new Object()
                objFile.fileurl = tmpfile
                objFile.filename =tmpfilename
                objFile.active=true
                if(tmpfiletype){
                    objFile.filetype =tmpfiletype
                } 
                if(tmpfilepath){
                    objFile.filepath =tmpfilepath
                }                                
                objFile.datecreated = new Date().getTime()
                var isImage = payload.isImage
                //console.log('tmpfile', tmpfile)
                //console.log('isImage', isImage)
                //console.log('objFile', objFile)
                //var collectionRef = firebase.firestore().collection(payload.post.org);
                var collectionRef = firebase.firestore().collection(payload.post.org).doc(payload.post.postid)      
                collectionRef.get().then(doc=>{
                    if(isImage){
                        collectionRef.update({images: firebase.firestore.FieldValue.arrayUnion(objFile)});
                        event('post', 'fileupload', 'Image' ) //GA EVENT
                      }else{
                        collectionRef.update({files: firebase.firestore.FieldValue.arrayUnion(objFile)});
                        event('post', 'fileupload', 'File' ) //GA EVENT
                      }                      
                      //console.log('updating file in document w/ docid: ' + doc.id)
                      
                      resolve('success')
                      commit('setLoading', false)                    
                }).catch(err => {
                    //console.log('Error getting documents', err);
                    reject('failure')
                    commit('setLoading', false)                    
                  })

            })
        },
        addFileToUploadHistory ({commit}, payload) {
            return new Promise((resolve, reject) => {    
                commit('setLoading', true)
                var tmpfile = payload.fileurl
                var tmpfilepath = payload.filepath
                var org = null
                var chapter = null

                var objFileHistoryItem = new Object()
                objFileHistoryItem.fileurl = tmpfile
                objFileHistoryItem.filepath = tmpfilepath
                
                if(payload.post){
                    objFileHistoryItem.type = 'post'
                    objFileHistoryItem.postid = payload.post.postid
                    objFileHistoryItem.org = payload.post.org
                    objFileHistoryItem.chapter = payload.post.chapter
                    objFileHistoryItem.userid = payload.post.authorid
                    objFileHistoryItem.name = payload.post.authorname

                    org =  payload.post.org
                    chapter =  payload.post.chapter
                }

                if(payload.checkin){
                    objFileHistoryItem.type = 'checkin'
                    objFileHistoryItem.checkinid = payload.checkin.checkinid
                    objFileHistoryItem.org = payload.checkin.org
                    objFileHistoryItem.chapter = payload.checkin.chapter
                    objFileHistoryItem.userid = payload.checkin.userid
                    objFileHistoryItem.expiringdatetime = payload.checkin.expiringdatetime

                    org =  payload.checkin.org
                    chapter =  payload.checkin.chapter                    
                }    
                
                if(payload.type && payload.type==='gallery'){
                    objFileHistoryItem.type = 'gallery'
                    objFileHistoryItem.org = payload.member.org
                    objFileHistoryItem.chapter = payload.member.chapter
                    objFileHistoryItem.userid = payload.member.userid


                    org =  payload.member.org
                    chapter =  payload.member.chapter                    
                }     
                
                if(payload.type && payload.type==='profilepic'){
                    objFileHistoryItem.type = 'profilepic'
                    objFileHistoryItem.org = payload.member.org
                    objFileHistoryItem.chapter = payload.member.chapter
                    objFileHistoryItem.userid = payload.member.userid


                    org =  payload.member.org
                    chapter =  payload.member.chapter                    
                }                    
                
                //console.log('objFileHistoryItem', objFileHistoryItem)
                var uploadhistorydocid = 'uploadhistory/' + chapter + '/list' 
                var collectionRef = firebase.firestore().collection(org)
                collectionRef.doc(uploadhistorydocid).get().then(doc=> {
                    if (doc.exists) {
                        collectionRef.doc(uploadhistorydocid).update({uploads: firebase.firestore.FieldValue.arrayUnion(objFileHistoryItem)});                            
                        resolve('success')
                        commit('setLoading', false) 
                    } else {
                        collectionRef.doc(uploadhistorydocid).set({uploads: firebase.firestore.FieldValue.arrayUnion(objFileHistoryItem)});                        }
                        resolve('success')
                        commit('setLoading', false) 
                }).catch(function(error) {
                    //console.log("Error getting document:" + uploadhistorydocid, error);
                    reject('failure')
                    commit('setLoading', false) 
                })
            })            
        },
        initPostSynch({commit}, payload) {
            //console.log('inside initPostSynch, payload=', payload)
            var postCats = Object.keys(payload.listPostTypes)
            postCats.forEach(function(c){
                var postCat = c
                //console.log('initPostSynch category ' + postCat)
                commit('setLoading', true)
                //const chapterCategoryPostsCollection = firebase.firestore().collection(payload.org).where('isPost', '==', true).where('chapter', '==', payload.chapter).where('category', '==', postCat)
                const chapterCategoryPostsCollection = firebase.firestore().collection(payload.org + '/posts/' + payload.chapter ).where('isPost', '==', true).where('chapter', '==', payload.chapter).where('category', '==', postCat).where('isactive', '==', true)
                chapterCategoryPostsCollection
                .onSnapshot((chapterCategoryPostsRef) => {
                  const tmpPosts = [];
                  chapterCategoryPostsRef.forEach((doc) => {
                    const tmpPost = doc.data();
                    tmpPost.id = doc.id;
                    tmpPost.datecreated = moment(tmpPost.datecreated).format(DATEFORMAT)
                    tmpPost.datemodified = moment(tmpPost.datemodified).format(DATEFORMAT)
                    if(tmpPost.comments && tmpPost.comments.length>0){
                        tmpPost.comments = tmpPost.comments.map(c=>{
                            c.datecreated = moment(c.datecreated).format(DATEFORMAT)
                            return c
                        })
                    }
                    tmpPosts.push(tmpPost);
                  })
                  var tmpSetMethodName = 'set' + postCat.substring(0,1).toUpperCase() + postCat.substring(1) + 'Posts'
                  //console.log('tmpSetMethodName', tmpSetMethodName)
                  commit(tmpSetMethodName, tmpPosts)
                })
                commit('addSnapshotlistener', chapterCategoryPostsCollection)
                commit('setLoading', false)
            })
            //SETTING MYPOSTS
            commit('setLoading', true)
            const chapterMyPostsCollection = firebase.firestore().collection(payload.org + '/posts/' + payload.chapter).where('isPost', '==', true).where('chapter', '==', payload.chapter).where('authorid', '==', payload.userid).where('isactive', '==', true)
            chapterMyPostsCollection
            .onSnapshot((chapterMyPostsRef) => {
              const tmpMyPosts = [];
              chapterMyPostsRef.forEach((doc) => {
                const tmpMyPost = doc.data();
                tmpMyPost.id = doc.id;
                tmpMyPost.datecreated = moment(tmpMyPost.datecreated).format(DATEFORMAT)
                tmpMyPost.datemodified = moment(tmpMyPost.datemodified).format(DATEFORMAT)
                if(tmpMyPost.comments && tmpMyPost.comments.length>0){
                    tmpMyPost.comments = tmpMyPost.comments.map(c=>{
                        c.datecreated = moment(c.datecreated).format(DATEFORMAT)
                        return c
                    })
                }                
                tmpMyPosts.push(tmpMyPost);
              });

              commit('setMyPosts', tmpMyPosts)
            })
            commit('addSnapshotlistener', chapterMyPostsCollection)
            commit('setLoading', false)

            //SETTING MYPOSTSCOMMENTED
            commit('setLoading', true)
            const chapterMyPostsCommentedCollection = firebase.firestore().collection(payload.org + '/posts/' + payload.chapter).where('isPost', '==', true).where('isactive', '==', true).where('chapter', '==', payload.chapter).where('participatingmemberids', 'array-contains', payload.userid)
            chapterMyPostsCommentedCollection
            .onSnapshot((chapterMyPostsCommentedRef) => {
              const tmpMyPostsCommented = [];
              chapterMyPostsCommentedRef.forEach((doc) => {
                const tmpMyPostCommented = doc.data();
                tmpMyPostCommented.id = doc.id;
                tmpMyPostCommented.datecreated = moment(tmpMyPostCommented.datecreated).format(DATEFORMAT)
                tmpMyPostCommented.datemodified = moment(tmpMyPostCommented.datemodified).format(DATEFORMAT)
                if(tmpMyPostCommented.comments && tmpMyPostCommented.comments.length>0){
                    tmpMyPostCommented.comments = tmpMyPostCommented.comments.map(c=>{
                        c.datecreated = moment(c.datecreated).format(DATEFORMAT)
                        return c
                    })
                }                   
                tmpMyPostsCommented.push(tmpMyPostCommented);
              })

              commit('setMyPosts', tmpMyPostsCommented)
            })
            commit('addSnapshotlistener', chapterMyPostsCommentedCollection)
            commit('setLoading', false)   
            commit('setIsSyncedPosts', true)           

        },
        getStorage({commit}){
            return firebase.storage()
        },
        onUpload ({commit}, {doUpload}){
          doUpload()
        },
        onDelete({commit}, {doDelete}){
          doDelete()
        }        
    },
    getters: {
        careerPosts (state) {
            return state.careerPosts
        },
        businessPosts (state) {
            return state.businessPosts
        },
        eventPosts (state){
            return state.eventPosts
        },
        infoPosts (state) {
            return state.infoPosts
        },
        myPosts (state) {
            return state.myPosts
        },
        myPostsCommented (state) {
            return state.myPostsCommented
        },
        isSyncedPosts (state){
            return state.isSyncedPosts
        }               
    }
  }